import moment from 'moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../App';
import { BV, formatVP } from '../../../helpers/helperFunctions';
import { P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { FlexCenter } from '../../../styles/stylesStyled';
import { LevelZero } from '../common/desktop';
import { getVolume } from '../myTeamBackOffice.actions';
import {
  FlexCenterEqual,
  VolumesDate,
  VolumesDesktop,
  VolumesInfo
} from '../MyTeamBackofficeStyled';
import UserComponent from '../UserComponent';
import Week from './Week';

const Volume = ({ tab }) => {
  const { t } = useTranslation('myTeam');
  const { volumeInfo } = useSelector((state) => state.myTeamBackoffice);
  const { user } = useSelector((state) => state.auth.userInfo);

  const { userAsTeamMember, userAsTeamMemberInfo, levels } = useSelector(
    (state) => state.myTeamBackoffice
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (!volumeInfo) dispatch(getVolume());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // if (isLoading) return <Spinner fullScreen={true} />;

  if (!volumeInfo)
    return (
      <P3 center color={color.colors.neutral0}>
        {t('volume_points_page.no_vol_points')}
      </P3>
    );

  return (
    <>
      <Desktop>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
          <LevelZero
            teamMember={userAsTeamMember}
            teamMemberInfo={userAsTeamMemberInfo}
            tab={tab}
          />
          <Flexed mt='32'></Flexed>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative'
            }}>
            {volumeInfo?.weekVolumeInfos?.map((week, i) => {
              return (
                <VolumesDesktop key={i} isCurrentWeek={i === 0}>
                  <VolumesDate>
                    {moment(week.weekStartDate).format('DD MMM')} {' - '}
                    {moment(week.weekEndDate).format('DD MMM YY')}
                  </VolumesDate>
                  <Flexed
                    style={{
                      borderRadius: '0 15px 15px 15px',
                      overflow: 'hidden'
                    }}>
                    <VolumesInfo>
                      <h1>{t('volume_points_page.initial_balance')}</h1>
                      <FlexCenterEqual>
                        <div>
                          <h2>
                            {t('left_team')} {BV}
                          </h2>
                          <h3>{formatVP(week.startLeftLegVolume)}</h3>
                        </div>
                        <div>
                          <h2>
                            {t('right_team')} {BV}
                          </h2>
                          <h3>{formatVP(week?.startRightLegVolume)}</h3>
                        </div>
                      </FlexCenterEqual>
                    </VolumesInfo>

                    <VolumesInfo>
                      <h1>{t('volume_points_page.new_balance')}</h1>
                      <FlexCenterEqual>
                        <div>
                          <h2>
                            {t('left_team')} {BV}
                          </h2>
                          <h3> {formatVP(week.newLeftLegVolume)}</h3>
                        </div>
                        <div>
                          <h2>
                            {t('right_team')} {BV}
                          </h2>
                          <h3>{formatVP(week.newRightLegVolume)}</h3>
                        </div>
                      </FlexCenterEqual>
                    </VolumesInfo>
                  </Flexed>
                </VolumesDesktop>
              );
            })}
          </div>
        </div>
      </Desktop>

      <Mobile style={{ width: '100%' }}>
        <FlexCenter style={{ flexDirection: 'column' }}>
          <UserComponent user={userAsTeamMember} />
        </FlexCenter>
        {volumeInfo?.weekVolumeInfos?.map((week, i) => {
          return (
            <Week
              key={i}
              week={week}
              isCurrentWeek={i === 0}
              numOfWeek={volumeInfo?.weekVolumeInfos.length - i}
            />
          );
        })}
      </Mobile>
    </>
  );
};

export default Volume;
